import React, { forwardRef } from 'react';

import { Stack, StackProps } from './Stack';

interface ScrollerProps extends StackProps {
  direction: 'row' | 'column';
  hideScrollbar?: boolean;
  spacing?: number;
  onScroll?: (event: React.UIEvent<HTMLElement>) => void;
}

export const Scroller = forwardRef<HTMLDivElement, ScrollerProps>(
  ({ direction = 'row', hideScrollbar, sx, spacing, ...props }, ref) => {
    const styles = [
      {
        overscrollBehavior: 'contain',
        WebkitOverflowScrolling: 'touch',
      },
      direction === 'row' && {
        overflowX: 'auto',
        width: '100%',
      },
      direction === 'column' && {
        overflowY: 'auto',
        height: '100%',
      },
      hideScrollbar && {
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        '&::-webkit-scrollbar': {
          width: 0,
          height: 0,
        },
      },
    ];
    return (
      <Stack
        direction={direction}
        spacing={spacing}
        sx={[...styles, ...(Array.isArray(sx) ? sx : [sx])]}
        ref={ref}
        onScroll={(e) => {
          e.stopPropagation();
        }}
        classes={['scroller']}
        {...props}
      ></Stack>
    );
  }
);

Scroller.displayName = 'Scroller';
